import natsort from "natsort";
import {defineComponent} from "vue";

const sortFn = natsort();

export default defineComponent({
  methods: {
    /**
     * ソート関数を生成します
     *
     * @param expandFn 行から値を抽出する関数
     */
    buildSort(expandFn: (row: any) => string | number) {
      return (a: any, b: any) => sortFn(expandFn(a), expandFn(b));
    }
  }
});
